// Schema for Create CPA onboarding flow
// Simple form with only Personal Information

export const CREATE_CPA_SCHEMA = {
  Personal_Info: [
    {
      section: "Create Your Pro Account",
      fields: [
        {
          name: "firstname",
          label: "First Name",
          type: "input",
          required: true,
          input_type: "text",
        },
        {
          name: "lastname",
          label: "Last Name",
          type: "input",
          required: true,
          input_type: "text",
        },
        {
          name: "email",
          label: "Email",
          type: "input",
          required: true,
          input_type: "email",
        },
        {
          name: "password",
          label: "Password",
          type: "input",
          required: true,
          input_type: "password",
        },
        {
          name: "license_type",
          label: "What kind of license do you have?",
          type: "radio_group",
          required: true,
          //display_as_heading: true,
          option: "cpaLicenseTypes",
          titleTooltip: "About your license",
          description:
            "Select the credential you currently hold. Only actively licensed CPAs, Enrolled Agents, and Tax Attorneys can join the Plaintr network.",
          marginTop: 20,
          marginBottom: 20,
        },
      ],
    },
  ],
};

export default CREATE_CPA_SCHEMA;
